<template>
    <v-app>
        <transition name="fade" mode="out-in">
        <v-main>
            <v-container fluid fill-height>
                <router-view></router-view>
            </v-container>
        </v-main>
        </transition>
    </v-app>
</template>

<script>

    import { Component, Vue } from 'vue-property-decorator';

    @Component
    export default class Auth extends Vue
    {
        //
    };
    
</script>